<template>
    <v-card flat>
        <v-row>
            <v-col cols="12" sm="12" class="pt-6">
                <v-form v-model="validated">
                    <v-row class="d-flex align-center">
                        <v-col cols="12" sm="6" class="px-6">
                            <v-text-field
                                     @input="itemChange"
                                     v-model="companyLawData.address"
                                     :label="$t('addressLaw')"
                                     class="pa-0 ma-0"
                                     color="orange lighten-2"
                                     :rules="rules"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="px-6">
                            <v-text-field
                                     @input="itemChange"
                                     v-model="companyLawData.edprou"
                                     :label="$t('edprou')"
                                     class="pa-0 ma-0"
                                     color="orange lighten-2"
                                     :rules="rules"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex">
                        <v-col cols="12" sm="4" class="px-6">
                            <v-text-field
                                     @input="itemChange"
                                     v-model="companyLawData.bankFullName"
                                     :label="$t('bankName')"
                                     class="pa-0 ma-0"
                                     color="orange lighten-2"
                                     :rules="rules"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" class="px-6">
                            <v-text-field
                                     @input="itemChange"
                                     v-model="companyLawData.bankMfo"
                                     :label="$t('bankMfo')"
                                     class="pa-0 ma-0"
                                     color="orange lighten-2"
                                     :rules="rules"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" class="px-6">
                            <v-text-field
                                     @input="itemChange"
                                     v-model="companyLawData.bankAccount"
                                     :label="$t('bankAccount')"
                                     class="pa-0 ma-0"
                                     color="orange lighten-2"
                                     :rules="rules"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        name: "LawCompanyInfo",
        props: ['initialLawData'],
        data() {
            return {
                validated: false,
                rules: [value => !!value || this.$t('requiredField')],
                companyLawData: {
                    address: '',
                    edprou: '',
                    bankAccount: '',
                    bankMfo: '',
                    bankFullName: '',
                },
            }
        },
        methods: {
            itemChange() {
                const data = this.companyLawData;
                let isValid = true;

                if (!this.validate(data)) {
                    isValid = false;
                }

                this.$emit('list-change', {data, isValid});
            },
            validate(company) {
                /*let valid = false;

                if(company.edprou && company.bankAccount && company.bankMfo && company.bankFullName) {
                    valid = true;
                } else {
                    valid = false;
                }
                return valid;*/
                return company;
            }
        },
        beforeMount() {
            this.companyLawData = this.initialLawData;
        },
        watch: {
            initialLawData: {
                handler() {
                    if(this.initialLawData) {
                        this.companyLawData = this.initialLawData;
                    }
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>